export default {
  path: '/blackspot',
  name: 'blackspot',
  meta: {
    moduleName: 'blackspots_module',
  },
  redirect: '/blackspot/blackspot-list', // default child route
  component: () =>
    import(/* webpackChunkName: "main" */ '@/views/BlackspotModule.vue'),
  children: [
    {
      path: 'constraints-update/:id',
      name: 'blackspotConstraintsUpdate',
      meta: {
        requiredRights: ['GEOV3_BLACKSPOT_CONTRAINTS_EDIT'],
        moduleName: 'blackspots_module',
      },
      component: () =>
        import(
          /* webpackChunkName: "main" */ '@/views/BlackspotConstraintsUpdate.vue'
        ),
    },
    {
      path: 'constraints-create',
      name: 'blackspotConstraintsCreate',
      meta: {
        requiredRights: ['GEOV3_BLACKSPOT_CONTRAINTS_ADD'],
        moduleName: 'blackspots_module',
      },
      component: () =>
        import(
          /* webpackChunkName: "main" */ '@/views/BlackspotConstraintsCreate.vue'
        ),
    },
    {
      path: 'constraints-list',
      name: 'blackspotConstraintsList',
      meta: {
        requiredRights: ['GEOV3_BLACKSPOT_CONTRAINTS_VIEW'],
        moduleName: 'blackspots_module',
      },
      component: () =>
        import(
          /* webpackChunkName: "main" */ '@/views/BlackspotConstraintsList.vue'
        ),
    },
    {
      path: 'constraints-table',
      name: 'blackspotConstraintsTable',
      meta: {
        requiredRights: ['GEOV3_BLACKSPOT_CONTRAINTS_VIEW'],
        moduleName: 'blackspots_module',
      },
      component: () =>
        import(
          /* webpackChunkName: "main" */ '@/views/BlackspotConstraintsTable.vue'
        ),
    },
    {
      path: 'constraints-table-map',
      name: 'blackspotConstraintsTableMap',
      meta: {
        requiredRights: ['GEOV3_BLACKSPOT_CONTRAINTS_VIEW'],
        moduleName: 'blackspots_module',
      },
      component: () =>
        import(
          /* webpackChunkName: "main" */ '@/views/BlackspotConstraintsTableMap.vue'
        ),
    },
    {
      path: 'blackspot-update/:id',
      name: 'blackspotUpdate',
      meta: {
        requiredRights: ['GEOV3_BLACKSPOT_EDIT'],
        moduleName: 'blackspots_module',
      },
      component: () =>
        import(/* webpackChunkName: "main" */ '@/views/BlackspotUpdate.vue'),
    },
    {
      path: 'blackspot-create',
      name: 'blackspotCreate',
      meta: {
        requiredRights: ['GEOV3_BLACKSPOT_ADD'],
        moduleName: 'blackspots_module',
      },
      component: () =>
        import(/* webpackChunkName: "main" */ '@/views/BlackspotCreate.vue'),
    },
    {
      path: 'blackspot-list',
      name: 'blackspotList',
      meta: {
        requiredRights: ['GEOV3_BLACKSPOT_ACCESS'],
        moduleName: 'blackspots_module',
      },
      component: () =>
        import(/* webpackChunkName: "main" */ '@/views/BlackspotList.vue'),
    },
    {
      path: 'blackspot-table',
      name: 'blackspotTable',
      meta: {
        requiredRights: ['GEOV3_BLACKSPOT_ACCESS'],
        moduleName: 'blackspots_module',
      },
      component: () =>
        import(/* webpackChunkName: "main" */ '@/views/BlackspotTableView.vue'),
    },
    {
      path: 'blackspot-table-map',
      name: 'blackspotTableMap',
      meta: {
        requiredRights: ['GEOV3_BLACKSPOT_ACCESS'],
        moduleName: 'blackspots_module',
      },
      component: () =>
        import(
          /* webpackChunkName: "main" */ '@/views/BlackspotTableMapView.vue'
        ),
    },
    {
      path: 'blackspot-import',
      name: 'blackspotImport',
      meta: {
        requiredRights: ['GEOV3_BLACKSPOT_IMPORT'],
        moduleName: 'blackspots_module',
      },
      component: () =>
        import(/* webpackChunkName: "main" */ '@/views/BlackspotImport.vue'),
    },
  ],
}
